import React from 'react';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import { get } from 'lodash';
import { convertForLocale, inferUnit } from 'util/unitConversion';

import ZoneSoilCompositionContainer from 'edit/ZoneSoilCompositionConnect';
import { useAppSelector } from 'app/hooks';
import { isMultiLayerZoneGenerationEnabled } from 'manual/selectors';
import { getPercentage } from 'util/unit';
import DeadZoneInfo from 'common/DeadZoneInfo';

const baseString = 'vra-zone-meta';

const ZoneMeta = ({
  isCheckStrip,
  zoneArea,
  zoneDisplayNumber,
  zoneId,
  zoneProductivity,
  isDeadZone
}) => {
  const isMultiLayerEnabled = useAppSelector(isMultiLayerZoneGenerationEnabled);
  const convertedZoneArea = convertForLocale({
    quantity: get(zoneArea, 'q', 0),
    unit: get(zoneArea, 'u', inferUnit('area').unitKey),
    unitType: 'area'
  }).toString({fullName: false});
  const isNegative = !!zoneProductivity && zoneProductivity < 0;
  const formattedZoneProductivity = getPercentage(zoneProductivity, { isPlusMinus: true });
  const classString = classNames({
    [`${baseString}`]: true,
    isMultiLayerEnabled
  });
  const productivityClassString = classNames({
    isNegative,
    'zone-relative-productivity': true
  });

  const zoneAreaContent = <span className='zone-area' data-test-id='zone-area'>{convertedZoneArea}</span>;

  const headerContent = isMultiLayerEnabled ? (
    <>
      <div>
        {getMessage('title-text__zone', { num: zoneDisplayNumber })}
        {(!!zoneProductivity || zoneProductivity === 0 )&& <div
          data-test-id="zone-relative-productivity"
          className={productivityClassString}
        >{formattedZoneProductivity}</div>}
        {isDeadZone && <DeadZoneInfo />}
      </div>
      {zoneAreaContent}
    </>
  ) : (
    <>
      {getMessage('title-text__zone', { num: zoneDisplayNumber })}
      {zoneAreaContent}
    </>
  );

  return (
    <section className={classString}>
      <header className={`${baseString}__name`} data-test-id='vra-zone-name'>{headerContent}</header>
      {isCheckStrip
        ? <div 
          className={`${baseString}__check-strip-label`} 
          data-test-id={`check-strip-label`}>
          {getMessage('label-text__check-strip-zone')}
        </div>
        : null
      }
      <ZoneSoilCompositionContainer zoneId={zoneId} />
    </section>
  );
};

ZoneMeta.propTypes = {
  isCheckStrip: propTypes.bool,
  zoneArea: propTypes.object.isRequired,
  zoneDisplayNumber: propTypes.number.isRequired,
  zoneId: propTypes.string.isRequired,
  zoneProductivity: propTypes.number,
  isDeadZone: propTypes.bool
};
export default ZoneMeta;
